export const checkStringSize = (str: string): number => {
  return new Blob([str]).size
}